import React, { useState } from 'react';

type ImageWithFallbackProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  fallback: string;
};

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({ src, fallback, alt, ...rest }) => {
  const [imgSrc, setImgSrc] = useState(src);

  return <img {...rest} src={imgSrc || fallback} onError={() => setImgSrc(fallback)} alt={alt} />;
};

export default ImageWithFallback;
